import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defaultTo, filter, find, propEq, compose, not, isNil, path } from 'ramda';

import magic from '../../../../../util/magic';
import { isNilOrEmpty } from '../../../../../util/redux';

import Accordion from '../../../../../components/Accordion/index';
import Step from '../../../../../components/Accordion/Step';
import {
  Pathway,
  Modules,
  SupportingDocumentation,
  CourseMaterials,
  Shipping,
  Membership,
  Donation,
  Summary,
} from '../Steps/index';
import UniversityInformation from '../Steps/UniversityInformation';
import PathwaySummary from '../Steps/PathwaySummary';
import PreRegistrationProgressIndicator from '../Steps/Components/PreRegistrationProgressIndicator';

class PreRegistration extends Component {
  static propTypes = {
    donations: PropTypes.array,
    certification: PropTypes.object,
    memberships: PropTypes.array,
    registration: PropTypes.object,
    user: PropTypes.object,
  };

  static defaultProps = {
    registration: {},
  };

  state = {
    percentageComplete: 0,
  };

  render() {
    const { certification, registration, user } = this.props;
    const { percentageComplete } = this.state;
    const pathway = defaultTo({}, find(propEq('id', Number(registration.pathwayTypeId)), certification.pathwayTypes));
    const reviews = defaultTo([], registration.reviews);
    const isUniversityPathway = pathway.key == magic.universityPathway;
    const hasModules = !isNilOrEmpty(certification.trainings);
    const isActiveMember = path(['membership', 'valid'], user);

    // TODO: Make less hardcoded
    const isFFCRegistration = certification.id == 7;
    const afcCertification = find(
      (c) => c.status == magic.certificateGoodStanding && c.certificationId == 1,
      user.userCertifications,
    );
    const mmeTraining = find(propEq('trainingId', 4), user.userTrainings);

    const stepProps = {
      ...this.props,
      pathway,
    };
    const steps = filter(compose(not, isNil), [
      hasModules
        ? { as: Modules, name: 'modules', title: 'Modules' }
        : { as: Pathway, name: 'pathway', title: 'Pathway' },
      isUniversityPathway ? { as: UniversityInformation, name: 'university', title: 'University Information' } : null,
      isFFCRegistration 
        ? null
        : {
            as: SupportingDocumentation,
            name: 'documentation',
            title: `Supporting Documentation${!pathway.requiresPreapproval && !hasModules ? ' (optional)' : ''}`,
          },
      pathway.requiresPreapproval ? { as: PathwaySummary, name: 'pathway_summary', title: 'Pathway Review' } : null,
      {
        as: CourseMaterials,
        name: 'course_materials',
        title: hasModules ? 'Module 1 Training Dates' : 'Course Materials',
      },
      isFFCRegistration ? null : { as: Shipping, name: 'shipping', title: 'Shipping' },
      isActiveMember || window.env.REACT_CLOSE_MEMBERSHIP_SIGNUP == true
        ? null
        : { as: Membership, name: 'membership', title: 'Membership (optional)' },
      isFFCRegistration ? null : { as: Donation, name: 'donation', title: 'Donation (optional)' },
      { as: Summary, name: 'summary', title: 'Pay & Review' },
    ]);

    return (
      <div className="row">
        <PreRegistrationProgressIndicator
          container={this}
          name={certification.name}
          reviews={reviews}
          percentageComplete={percentageComplete}
        />
        <div className="col-xs-12 col-sm-8">
          <Accordion
            step={registration.step}
            onPercentageChanged={(percent) => this.setState({ percentageComplete: percent })}
          >
            {steps.map((step) => (
              <Step key={step.name} {...step} {...stepProps} />
            ))}
          </Accordion>
        </div>
      </div>
    );
  }
}

export default PreRegistration;
